import React, { useCallback } from 'react'
import * as Icons from 'assets/icons/groove/v2'
import Menu from '@groovehq/internal-design-system/lib/components/Menu/Menu'
import Item from '../Item'

export default function Group({
  groupId,
  name,
  open,
  onClick,
  icon,
  folderIds,
}) {
  const handleClick = useCallback(
    () => {
      if (onClick) onClick(groupId)
    },
    [onClick, groupId]
  )
  const GroupIcon = Icons[icon]

  return (
    <Menu.Item
      key={groupId}
      icon={<GroupIcon />}
      defaultOpen={open}
      onClick={handleClick}
      hasArrow
      subMenu={
        <>
          {open &&
            folderIds.map(listId => (
              <Item key={listId} itemId={listId} padded={4} isSubMenuItem />
            ))}
        </>
      }
    >
      {name}
    </Menu.Item>
  )
}
